module.exports = __webpack_public_path__ + "img/library.1138f0cf.jpg";